import { Injectable } from '@angular/core';
import { VigenciaFiscalService } from 'app/main/datos-basicos/services/vigencia-fiscal-service.service';
import { VigenciaFiscal } from 'app/main/datos-basicos/entities/vigencia-fiscal';

@Injectable({
    providedIn: 'root'
})
export class VigenciaSistemaService {

    vigencia: VigenciaFiscal;

    constructor(
    ) {
        this.getVigencia();
    }

    establecerVigencia(vigenciaAGuardar: VigenciaFiscal) {
        this.vigencia = vigenciaAGuardar;
        localStorage.setItem("vigencia", JSON.stringify(this.vigencia));
        window.location.reload();
    }

    private getVigencia() {
        let vigenciaGuardada = localStorage.getItem("vigencia");
        if (vigenciaGuardada != null && vigenciaGuardada != "") {
            this.vigencia = JSON.parse(vigenciaGuardada);
        }
    }

}
